<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

<ng-container *ngIf="modal$ | async as modal">
  <div *ngIf="modal" class="container-modal-list js-container-modal-list" (click)="close($event)">
    <modal-unit [modal]="modal"></modal-unit>
  </div>
</ng-container>
